import QRProduct from "components/card/product/QRProduct";
import PaymentHistoryGateway from "components/PaymentHistoryGateway";
import { Route, Routes } from "react-router-dom";
import Logout from "routes/account/mypage/Logout";
import MyPageInfo from "routes/account/mypage/MyPageInfo";
import MyPageLayout from "routes/account/mypage/MyPageLayout";
import TrackOrderDetail from "routes/account/mypage/order/TrackOrderDetail";
import TrackOrderLayout from "routes/account/mypage/order/TrackOrderLayout";
import ShippingInfoLayout from "routes/account/mypage/shippingInfo/ShippingInfoLayout";
import WishListLayout from "routes/account/mypage/wishList/WishListLayout";
import Article from "routes/article/Article";
import NoticeDetail from "routes/article/notice/NoticeDetail";
import EmptyPage from "routes/empty/EmptyPage";
import Test from "routes/empty/Test";
import PrivacyPolicy from "routes/front/footer/PrivacyPolicy";
import TermsOfUse from "routes/front/footer/TermsOfUse";
import FrontLayout from "routes/front/FrontLayout";
import Home from "routes/front/main/Home";
import SearchResult from "routes/front/main/productList/SearchResult";
import NewOrderSummary from "routes/front/main/shopping/NewOrderSummary";
import OrderComplete from "routes/front/main/shopping/OrderComplete";
import OrderFail from "routes/front/main/shopping/OrderFail";
import ProductDetail from "routes/front/main/shopping/ProductDetail";
import ShoppingLayout from "routes/front/main/shopping/ShoppingLayout";
import Payment2 from "routes/main/Payment2";
import PaymentComplete from "routes/main/PaymentComplete";
import PaymentFail from "routes/main/PaymentFail";
import PaymentGateway from "routes/main/PaymentGateway";
import WebSocketContainer from "routes/main/WebSocketContainer";
import PaymentLanding from "routes/mobile/payment/PaymentLanding";
import PaymentLandingGateway from "routes/mobile/payment/PaymentLandingGateway";
import { ADMIN, PARTNERS, USER } from "shared/Roles";
import RequireAuth from "shared/utils/RequireAuth";

function FrontRouter() {
  return (
    <Routes>
      <Route path="/ws/:id" element={<WebSocketContainer />} >
        <Route path="paymentHistory" element={<PaymentHistoryGateway />} />
        <Route path="landing" element={<PaymentLanding />} />
        <Route path="landingGateWay" element={<PaymentLandingGateway />} />
        <Route path="payment">
          <Route path="" element={<Payment2 />} />
          <Route path="gateway" element={<PaymentGateway />} />
          <Route path="complete" element={<PaymentComplete />} />
          <Route path="fail" element={<PaymentFail />} />
        </Route>
      </Route>
      <Route path="/" element={<FrontLayout />}>
        <Route path="" element={<Home />} />  {/* CLEAR */}
        <Route path="article">
          <Route path="notice">
            <Route path="" element={<Article type={"notice"} />} /> {/* CLEAR */}
            <Route path="detail" element={<NoticeDetail />} /> {/* CLEAR */}
          </Route>
        </Route>
        <Route path="productList" state={{ replace: true }}>
          <Route path="category/:categoryId" element={<SearchResult />} /> {/* CLEAR */}
        </Route>
        <Route
          path="mypage"
          exact
          element={<RequireAuth allowedRoles={[USER, ADMIN, PARTNERS]} />}
        >
          <Route path="" element={<MyPageLayout />}> {/* CLEAR */}
            <Route path="" exact element={<MyPageInfo />} /> {/* CLEAR */}
            <Route path="trackOrder" element={<TrackOrderLayout />} /> {/* CLEAR */}
            <Route path="trackOrder/detail" element={<TrackOrderDetail />} /> {/* CLEAR */}
            <Route path="shippingInfo" element={<ShippingInfoLayout />} /> {/* 보류 */}
            <Route path="logout" element={<Logout />} /> {/* CLEAR */}
          </Route>
        </Route>
        <Route
          path="shopping"
          element={<RequireAuth allowedRoles={[USER, ADMIN, PARTNERS]} />}
        >
          <Route path="" element={<ShoppingLayout />}>
            <Route path="orderSummary" element={<NewOrderSummary />} /> {/* CLEAR */}
            <Route path="orderComplete" element={<OrderComplete />} /> {/* CLEAR */}
          </Route>
        </Route>
        <Route path="orderFail" element={<OrderFail />} />
        <Route path="product/detail/:id" element={<ProductDetail />} />  {/* CLEAR */}
        <Route path="termsOfUse" element={<TermsOfUse />} /> {/* CLEAR */}
        <Route path="privacyPolicy" element={<PrivacyPolicy />} /> {/* CLEAR */}
        <Route path="wishlist" element={<WishListLayout />} />
        <Route path="qrByProduct" element={<QRProduct />} />
        {/* <Route path="test" element={<Test />} /> */}


      </Route>
      <Route path="*" element={<EmptyPage />} />
    </Routes>
  );
}

export default FrontRouter;
